import React from "react";
import useLinearProgress from "./hooks/useLinearProgress";
import { BaseLinearProgress, BaseLinearProgressIndicator } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function LinearProgress(_ref) {
  var value = _ref.value,
    indeterminate = _ref.indeterminate;
  var style = useLinearProgress(value);
  return /*#__PURE__*/_jsx(BaseLinearProgress, {
    children: /*#__PURE__*/_jsx(BaseLinearProgressIndicator, {
      indeterminate: !value && value !== 0 || indeterminate,
      style: style
    })
  });
}
export default LinearProgress;